// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2wh7P","col":"CardReaderDesc_col__1g3NF","label":"CardReaderDesc_label__2FrkH"};